import {
	AUTH_TOKEN,
	AUTHENTICATED,
	SHOW_AUTH_MESSAGE,
	HIDE_AUTH_MESSAGE,
	SIGNOUT_SUCCESS,
	SIGNUP_SUCCESS,
	SHOW_LOADING,
	SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
	RECENT_ACTIVITY_LOADING,
	RECENT_ACTIVITY,
	RECENT_LOGINS,
	RECENT_LOGINS_LOADING
} from '../constants/Auth';

const initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
  token: localStorage.getItem(AUTH_TOKEN),
	recentActivity: {
		loading: false,
		data: null
	},
	recentLogins: {
		loading: false,
		data: null
	}
}

const auth = (state = initState, action) => {
	switch (action.type) {
		case AUTHENTICATED:
			return {
				...state,
				loading: false,
				redirect: '/',
				token: action.token
			}
		case SHOW_AUTH_MESSAGE: 
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case HIDE_AUTH_MESSAGE: 
			return {
				...state,
				message: '',
				showMessage: false,
			}
		case SIGNOUT_SUCCESS: {
			return {
				...state,
				token: null,
				redirect: '/',
				loading: false
			}
		}
		case SIGNUP_SUCCESS: {
			return {
			  ...state,
			  loading: false,
			  token: action.token
			}
		}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case RECENT_ACTIVITY: {
			return {
				...state,
				recentActivity: {
					...state.recentActivity,
					data: action.payload
				}
			}
		}
		case RECENT_ACTIVITY_LOADING: {
			return {
				...state,
				recentActivity: {
					...state.recentActivity,
					loading: action.payload
				}
			}
		}
		case RECENT_LOGINS: {
			return {
				...state,
				recentLogins: {
					...state.recentLogins,
					data: action.payload
				}
			}
		}
		case RECENT_LOGINS_LOADING: {
			return {
				...state,
				recentLogins: {
					...state.recentLogins,
					loading: action.payload
				}
			}
		}
		default:
			return state;
	}
}

export default auth